import CoursesList from "./CourseList";
import { EducationIntroCard } from "./EducationIntroCard";
import EducationIntroDesc from "./EducationIntroDesc";
import MyCourses from "./MyCourses/MyCourses";
import "./index.css";

const EducationPage = () => {
  return (
    <div className="education-container-page">
      <div style={{ display: "flex", gap: "10px" }}>
        <EducationIntroCard />
        <EducationIntroDesc />
      </div>
      <CoursesList />
      <MyCourses />
    </div>
  );
};

export default EducationPage;
